
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6VQXY", function(module, exports) {

$parcel$export(module.exports, "ReadPopup", () => $1b0493e379fac10b$export$6d6315f08f93adaa);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $ccHMk = parcelRequire("ccHMk");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $dokWT = parcelRequire("dokWT");

var $1HYxw = parcelRequire("1HYxw");
const $1b0493e379fac10b$var$containerStyles = (0, $ecnYn.xcss)({
    width: '330px'
});
const $1b0493e379fac10b$export$6d6315f08f93adaa = ({ name: name, guideline: guideline, guidelineRepresentation: guidelineRepresentation = 'PLAIN', onChangeLevelClick: onChangeLevelClick, onChangeLevelMouseEnter: onChangeLevelMouseEnter })=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        padding: "space.250",
        xcss: $1b0493e379fac10b$var$containerStyles,
        role: "dialog",
        "aria-labelledby": "data-classification-read-content-name",
        "aria-describedby": "data-classification-read-content-guideline",
        "aria-modal": "true",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dokWT.ClassificationView), {
                name: name,
                guideline: guideline,
                guidelineRepresentation: guidelineRepresentation
            }),
            Boolean(onChangeLevelClick) && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                paddingBlockStart: "space.200",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bUlM5.default), {
                    justifyContent: "end",
                    gap: "space.100",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                        onClick: onChangeLevelClick,
                        onMouseEnter: onChangeLevelMouseEnter,
                        children: intl.formatMessage((0, $1HYxw.messages).changeLevel)
                    })
                })
            })
        ]
    });
};

});


//# sourceMappingURL=EditorContentClassificationTag.3959b120.js.map
